// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"a836f335","453":"369ef824","538":"86c08020","735":"79a23722","748":"7a2adfde"}[chunkId] + ".chunk.js";
};